// 机房控制系统

const machine = {
    path: '/',
    component: resolve => require(['@/views/Layout/MachineLayout'], resolve),
    title: "layout",
    children: [
        // 机房监控
        {
            path: '/machinemana1',
            component: resolve => require(['@/views/MachineMana/MonitoringMana/MonitoringMana'], resolve),
            name: 'machinemana2',
            meta: { title: '机房监控', breadcrumb: [{ menu: 'machinemana' }], role: 'machine', system: 1, }
        },
        // 机房监控
        {
            path: '/machinemana/:id',
            component: resolve => require(['@/views/MachineMana/MonitoringMana/MonitoringMana2'], resolve),
            name: 'machinemana',
            meta: { title: '机房监控', breadcrumb: [{ menu: 'machinemana' }], role: 'machine', system: 1, }
        },
        // 移动端组态设备控制
        {
            path: '/machinemana/mobile/:id',
            component: resolve => require(['@/views/MachineMana/mobileMonitoring/mobileMonitoring'], resolve),
            name: 'mobileMonitoring',
            meta: { breadcrumb: [{ menu: 'machinemana', path: '/machinemana' }, { menu: 'mobileMonitoring' }], role: 'machine', system: 1, }
        },
        // 能源 监控水泵设置
        {
            path: '/pumpsetting/pumpsetting',
            component: resolve => require(['@/views/MachineMana/PumpSetting/PumpSetting'], resolve),
            name: 'pumpsetting',
            meta: { title: '水泵设置', breadcrumb: [{ menu: 'machinemana', path: '/machinemana' }, { menu: 'pumpsetting' }], role: 'machine', system: 1, }
        },
        // 集控器管理
        {
            path: '/machinegateway',
            component: resolve => require(['@/views/MachineMana/GatewayMana/GatewayMana'], resolve),
            name: 'machineGatewayMana',
            meta: { title: '集控器管理', breadcrumb: [{ menu: 'gatewayMana' }], role: "collector", system: 1 },
        },
        // 添加表计
        {
            path: '/machinegateway/addmeter/:gatewayId',
            component: resolve => require(['@/views/MachineMana/GatewayMana/AddMeter/AddMeter'], resolve),
            name: 'addMeter1',
            meta: { title: '添加表计', breadcrumb: [{ menu: 'gatewayMana', path: "/machinegateway" }, { menu: 'addMeter' }], role: "collector", system: 1 }
        },
        // 变量设置
        {
            path: '/machinegateway/variableset/:gatewayId',
            component: resolve => require(['@/views/MachineMana/VariableSet/VariableSet'], resolve),
            name: 'variableset',
            meta: { title: '变量设置', breadcrumb: [{ menu: 'gatewayMana', path: "/machinegateway" }, { menu: 'variableset' }], role: "collector", system: 1 }
        },
        // PLC 子设备配置
        {
            path: '/machinegateway/plcterminal/:id',
            component: resolve => require(['@/views/MachineMana/PlcTerminalSet/index'], resolve),
            name: 'plcterminal',
            meta: { title: '子设备配置',  breadcrumb: [{ menu: 'gatewayMana', path: "/machinegateway" }, { menu: 'plcterminal' }], role: "collector", system: 1 }
        },
        
        // 变量管理
        {
            path: '/argmana',
            component: resolve => require(['@/views/MachineMana/ArgMana/ArgMana'], resolve),
            name: 'argmana',
            meta: { title: '变量管理', breadcrumb: [{ menu: 'argmana' }], role: "collector", system: 1}
        },
        // 页面配置
        {
            path: '/serverroom',
            component: resolve => require(['@/views/MachineMana/SetPagevar/SetPagevar'], resolve),
            name: 'deviceReportsetting',
            meta: { title: '报表设置', breadcrumb: [{ menu: 'deviceReportsetting' }], role: 'energybase', system: 1 }
        },
        // 设备工况
        {
            path: '/devicestatus',
            component: resolve => require(['@/views/MachineMana/DeviceRunningStatus/DeviceRunningStatus'], resolve),
            name: 'machineDeviceStatus',
            meta: { title: '设备工况', breadcrumb: [{ menu: 'machineDeviceStatus' }], role: 'device_report', system: 1 }
        },
        // 故障记录
        {
            path: '/faultlist',
            component: resolve => require(['@/views/MachineMana/DeviceFault/DeviceFault'], resolve),
            name: 'faultlist',
            meta: { title: '故障记录', breadcrumb: [{ menu: 'faultlist' }], role: "device_report", system: 1 }
        },
        // 数据曲线
        {
            path: '/deviceCurve',
            component: resolve => require(['@/views/MachineMana/DeviceCurve/DeviceCurve'], resolve),
            name: 'deviceCurve',
            meta: { title: '数据曲线', breadcrumb: [{ menu: 'deviceCurve' }], role: "device_report", system: 1 }
        },
        // 数据报表
        {
            path: '/deviceReport',
            component: resolve => require(['@/views/MachineMana/DeviceReport/DeviceReport'], resolve),
            name: 'deviceReport',
            meta: { title: '数据报表',  breadcrumb: [{ menu: 'deviceReport' }], role: "device_report", system: 1 }
        },
        // 定时管理
        {
            path: '/timerMana',
            component: resolve => require(['@/views/MachineMana/TimerMana/TimerMana'], resolve),
            name: 'timerMana',
            meta: { title: '定时管理', breadcrumb: [{ menu: 'timerMana' }], role: 'time_control', system: 1}
        },
        // 定时设置
        {
            path: '/timerMana/addtiming/:timingId',
            component: resolve => require(['@/views/MachineMana/TimerMana/TimerSetting'], resolve),
            name: 'setTiming',
            meta: { title: '定时设置', breadcrumb: [{ menu: 'timerMana', path: "/timerMana" }, { menu: 'setTiming' }], role: 'time_control', system: 1 }
        },
        // 参数设置
        // {
        //     path: '/argsetting',
        //     component: resolve => require(['@/views/MachineMana/ArgSetting/ArgSetting'], resolve),
        //     name: 'argSetting',
        //     meta: { title: '参数设置', breadcrumb: [{ menu: 'argSetting' }], role: "argsetting", system: 1 }
        // },
        // 温度设置
        {
            path: '/tempsetting',
            component: resolve => require(['@/views/MachineMana/ArgSetting/tempsetting'], resolve),
            name: 'tempsetting',
            meta: { title: '温度设置', breadcrumb: [{ menu: 'tempsetting' }], role: "tempsetting", system: 1 }
        },
        // 压力设置
        {
            path: '/pressuresetting',
            component: resolve => require(['@/views/MachineMana/ArgSetting/pressuresetting'], resolve),
            name: 'pressuresetting',
            meta: { title: '压力设置', breadcrumb: [{ menu: 'pressuresetting' }], role: "pressuresetting", system: 1 }
        },
        // 延时设置
        {
            path: '/delayedsetting',
            component: resolve => require(['@/views/MachineMana/ArgSetting/delayedsetting'], resolve),
            name: 'delayedsetting',
            meta: { title: '延时设置', breadcrumb: [{ menu: 'delayedsetting' }], role: "delayedsetting", system: 1 }
        },
        // 频率设置
        {
            path: '/frequencysetting',
            component: resolve => require(['@/views/MachineMana/ArgSetting/frequencysetting'], resolve),
            name: 'frequencysetting',
            meta: { title: '频率设置', breadcrumb: [{ menu: 'frequencysetting' }], role: "frequencysetting", system: 1 }
        },
        // 高级参数设置
        {
            path: '/advanceArgsetting',
            component: resolve => require(['@/views/MachineMana/ArgSetting/AdvancedArgSetting'], resolve),
            name: 'advanceArgsetting',
            meta: { title: '高级参数设置', breadcrumb: [{ menu: 'advanceArgsetting' }], role: "advancedArgsetting", system: 1 }
        },
        // 节能配置
        {
            path: '/energybase',
            component: resolve => require(['@/views/MachineMana/BaseSetting/index'], resolve),
            name: 'energybase',
            meta: { title: '节能配置', breadcrumb: [{ menu: 'energybase' }], role: 'energybase', system: 1 }
        },

        // 能源概况
        {
            path: '/EnergySituation',
            component: resolve => require(['@/views/MachineMana/EnergySituation/EnergySituation'], resolve),
            name: 'EnergySituation',
            meta: { title: '能源概况', breadcrumb: [{ menu: 'EnergySituation' }], role: 'energy_stuation', system: 1 }
        },
        // 系统节能
        {
            path: '/EnergySystem',
            component: resolve => require(['@/views/MachineMana/EnergySituation/EnergySystem'], resolve),
            name: 'EnergySystem',
            meta: { title: '系统节能', breadcrumb: [{ menu: 'EnergySystem' }], role: 'energy_system', system: 1 }
        },
        // 系统节能日报
        {
            path: '/EnergySystemDay',
            component: resolve => require(['@/views/MachineMana/EnergySituation/EnergySystemDay'], resolve),
            name: 'EnergySystemDay',
            meta: { title: '系统节能日报', breadcrumb: [{ menu: 'EnergySystemDay' }], role: 'energy_pump', system: 1 }
        },
        // 水泵节能日报
        {
            path: '/EnergyPumpDay',
            component: resolve => require(['@/views/MachineMana/EnergySituation/EnergyPumpDay'], resolve),
            name: 'EnergyPumpDay',
            meta: { title: '水泵节能日报', breadcrumb: [{ menu: 'EnergyPumpDay' }], role: 'energy_pump', system: 1 }
        },
        // 水泵节能
        {
            path: '/EnergyPump',
            component: resolve => require(['@/views/MachineMana/EnergySituation/EnergyPump'], resolve),
            name: 'EnergyPump',
            meta: { title: '水泵节能', breadcrumb: [{ menu: 'EnergyPump' }], role: 'energy_pump', system: 1 }
        },
        // 水泵节能列表
        {
            path: '/EnergyPumpList',
            component: resolve => require(['@/views/MachineMana/EnergySituation/EnergyPumpList'], resolve),
            name: 'EnergyPumpList',
            meta: { title: '水泵节能列表', breadcrumb: [{ menu: 'EnergyPumpList' }], role: 'energy_pump', system: 1 }
        },
        // 水泵节能明细
        {
            path: '/EnergyPumpList/EnergyPumpDetail/:id',
            component: resolve => require(['@/views/MachineMana/EnergySituation/EnergyPumpDetail'], resolve),
            name: 'EnergyPumpDetail',
            meta: { title: '水泵节能明细', breadcrumb: [{ menu: 'EnergyPumpList', path: "/EnergyPumpList"  },{ menu: 'EnergyPumpDetail' }], role: '', system: 1 }
        },
        // 日志管理
        {
            path: '/log',
            component: resolve => require(['@/views/MachineMana/LogMana/LogMana'], resolve),
            name: 'log',
            meta: { title: '日志管理', breadcrumb: [{ menu: 'log' }], role: '', system: 1 }
        },
        // 账号管理
        {
            path: '/role1',
            component: resolve => require(['@/views/SystemMana/RoleMana/RoleMana'], resolve),
            name: 'role1',
            meta: { title: '账号管理', breadcrumb: [{ menu: 'role' }], role: '', system: 1 }
        },
        // 权限控制
        {
            path: '/authority1',
            component: resolve => require(['@/views/SystemMana/AuthoritySetting/AuthoritySetting'], resolve),
            name: 'authority1',
            meta: { title: '权限控制', breadcrumb: [{ menu: 'authority' }], role: '', system: 1 }
        },
		// 消息中心
		{
		    path: '/message1',
		    component: resolve => require(['@/views/UserCenter/Message/Message'], resolve),
		    name: 'messageCenter',
		    meta: { title: '消息中心', breadcrumb: [{ menu: 'messageCenter' }] }
		},
		
		// 修改密码
		{
		    path: '/changepassword1',
		    component: resolve => require(['@/views/UserCenter/ChangePassword'], resolve),
		    name: 'changePassword',
		    meta: { title: '修改密码',  breadcrumb: [{ menu: 'changePassword' }] }
		},
		// 个人设置
		{
		    path: '/usercenter1',
		    component: resolve => require(['@/views/UserCenter/UserCenter'], resolve),
		    name: 'userEmail',
		    meta: { title: '绑定邮箱',  breadcrumb: [{ menu: 'userEmail' }] }
		},
		// 售后服务
		{
		    path: '/aftersales1',
		    component: resolve => require(['@/views/SystemMana/AfterSales/AfterSales'], resolve),
		    name: 'aftersales1',
		    meta: { title: '售后服务',  breadcrumb: [{ menu: 'aftersales' }], role: '' }
		},
    ]
};

export default machine